import React from "react";
import { VstDropdown } from "vstui";
import { Isvg } from "../../components";

export default class ChapterDropdownItem extends React.Component {
  constructor() {
    super();
    this.select = this.select.bind(this);
  }

  select() {
    this.props.select(this.props.title);
  }

  render() {
    const { title, selected } = this.props;
    return (
      <VstDropdown.Item onClick={this.select} selected={selected}>
        {title}
      </VstDropdown.Item>
    );
  }
}
